import { Modal } from "antd"
import { centsToDollarsDisplay } from "../displayFormatters"
import { hasValue } from "../../helpers/nullable"
import { PricingType, PricingTypes } from "../../common/constants"

export type Props = {
  currentFinalPrice: number
  estimatedPrice: number
  setCustomizedFinalPrice: (customizedFinalPrice: number | null) => void
  isOpen?: boolean
  alreadyInvoiced?: number
  pricingType: PricingType
}

const KeepFinalPriceModal = ({isOpen, currentFinalPrice, estimatedPrice, setCustomizedFinalPrice, alreadyInvoiced, pricingType}: Props) => {
  const resetToInvoiced = pricingType === PricingTypes.QuotedPrice && hasValue(alreadyInvoiced) && (alreadyInvoiced > estimatedPrice)
  const resetDisplayAmount = resetToInvoiced ? alreadyInvoiced : estimatedPrice
  const resetAmount = resetToInvoiced ? alreadyInvoiced : null

  return <Modal
    open={isOpen || isOpen === undefined}
    title="Keep the current Final Price?"
    okText={`Keep ${centsToDollarsDisplay(currentFinalPrice)}`}
    cancelText={`Reset to ${centsToDollarsDisplay(resetDisplayAmount)}`}
    closable={false}
    maskClosable={false}
    onOk={() => setCustomizedFinalPrice(currentFinalPrice)}
    onCancel={() => setCustomizedFinalPrice(resetAmount)}
  >
    <p>
      While approved, this work area had a Final Price which {resetToInvoiced ? 'was less than the invoiced amount' : 'did not match the Estimated Price'}.
      Do you want to keep the Final Price of {centsToDollarsDisplay(currentFinalPrice)},
      or reset to the {resetToInvoiced ? 'invoiced amount' : 'Estimated Price'}?
    </p>
  </Modal>
}

export default KeepFinalPriceModal